var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#E9EAED",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.9590625 -0.00773438 1.918125 -0.01546875 2.90625 -0.0234375 C5.5 0.375 5.5 0.375 7.34375 1.7109375 C8.5 3.375 8.5 3.375 8.5 6.375 C4.87 6.375 1.24 6.375 -2.5 6.375 C-2.5 9.345 -2.5 12.315 -2.5 15.375 C-0.52 15.375 1.46 15.375 3.5 15.375 C3.83 14.715 4.16 14.055 4.5 13.375 C6.15 13.375 7.8 13.375 9.5 13.375 C9.15002406 15.96482197 8.85941651 17.88329012 7.30078125 20.015625 C4.82336464 21.88577897 3.07669073 21.80836466 0 21.8125 C-0.9590625 21.83183594 -1.918125 21.85117187 -2.90625 21.87109375 C-5.5 21.375 -5.5 21.375 -7.3203125 19.7890625 C-8.91493225 16.52590024 -8.89783815 13.93234638 -8.875 10.3125 C-8.88273438 9.08402344 -8.89046875 7.85554687 -8.8984375 6.58984375 C-8.5 3.375 -8.5 3.375 -7.3203125 1.46484375 C-4.80409918 -0.04164448 -2.91789406 -0.0235314 0 0 Z ",
    fill: "#2064AD",
    transform: "translate(15.5,5.625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.6875 2.375 4.6875 2.375 4 5 C3.01 5.66 2.02 6.32 1 7 C0.01 6.67 -0.98 6.34 -2 6 C-2 5.34 -2 4.68 -2 4 C-3.32 3.67 -4.64 3.34 -6 3 C-5.195625 2.87625 -4.39125 2.7525 -3.5625 2.625 C-2.716875 2.41875 -1.87125 2.2125 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#3371B4",
    transform: "translate(20,19)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopo);
export default __webpack_public_path__ + "static/media/copo.2a19faf78fab251e84bb12e25a6ceac5.svg";
export { ForwardRef as ReactComponent };